<script>
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  import { CodeMirror } from '@client/components/codemirror';
  import { CopyText } from '@client/components/copy-text';
  import { getNotificationsContext } from '@client/components/notifications';

  import { SignaturesService } from '@client/services/signatures';

  import { minifyHTML } from '@client/utils/html-formatter';

  const { addNotification } = getNotificationsContext();

  export let config = {};

  let originalTemplate = (config.signature || '').slice();
  let saving = false;

  const notify = (text, error) => {
    addNotification({
      text,
      type: error ? 'error' : 'success',
      autohide: 2500,
      position: 'top-right'
    });
  };

  const onUpdateSignature = async () => {
    if (saving) return;

    saving = true;
    const signature = config.signature;

    try {
      const email = config.email;
      const html = minifyHTML(signature);
      const response = await SignaturesService.updateDefaultSignatures(email, email, config.id, html);

      if (
        !response ||
        response.status >= 400 ||
        (Array.isArray(response) && response.some((result) => result.status >= 400 || result.result === 'Error'))
      ) {
        notify($format('label.FAILURE.UPDATE_PUSHED_SIGNATURE'), true);
        return;
      }

      originalTemplate = signature;
      if (config.signature === signature) config.editing = false;
      notify($format('label.SUCCESS.UPDATE_SIGNATURE', { values: { type: config.label } }));
    } catch (error) {
      notify($format('label.FAILURE.UPDATE_PUSHED_SIGNATURE'), true);
    } finally {
      saving = false;
    }
  };

  const resizeIframe = function () {
    this.style.visibility = 'visible';
    this.style.height = this.contentWindow.document.body.firstChild.clientHeight + 20 + 'px';
    this.style.width = this.contentWindow.document.body.firstChild.clientWidth + 20 + 'px';
  };

  const insertPlainText = () => {
    config.signature = config.plaintext;
  };
</script>

<div class="default-signature">
  <div class="signature">
    <div class="controls">
      <div class="left-pane">
        <b>{$format('label.LAST_USED')}:</b>
        {config.lastUsedTimestamp}
      </div>
      <div class="right-pane">
        {#if !config.editing}
          <CopyText label={$format('label.COPY')} source={config.signature} />
          <Button color="primary" class="mx-2 me-0" size="sm" on:click={() => (config.editing = true)}>
            {$format('label.EDIT_SIGNATURE')}
          </Button>
        {:else}
          <Button class="me-1" color="secondary" size="sm" disabled={saving} on:click={insertPlainText}>
            {$format('label.INSERT_PLAIN_TEXT')}
          </Button>
          <Button
            class="me-1"
            color="secondary"
            size="sm"
            disabled={saving}
            on:click={() => {
              config.editing = false;
              config.signature = originalTemplate;
            }}
          >
            {$format('label.CANCEL')}
          </Button>
          <Button color="primary" size="sm" disabled={saving} on:click={onUpdateSignature}>
            {$format(saving ? 'label.SAVING' : 'label.UPDATE')}
          </Button>
        {/if}
      </div>
    </div>

    {#if config.signature === undefined}
      <br />
      <div>{$format('label.NO_DEFAULT_SIGNATURE_EXISTS')}</div>
    {:else}
      <iframe
        tabindex="-1"
        title="Signature Preview"
        style="width: 100%; visibility: hidden;"
        scrolling="no"
        on:load={resizeIframe}
        srcdoc="<html><head></head><body style='padding: 8px 0; margin: 0;'><div style='display: inline-block; padding: 0; margin: 0;'>{config.signature ||
          `<span style="color: #aaa; font-family: arial; font-size: 14px;">${$format('label.EMPTY')}</span>`}</div></body></html>"
      />
    {/if}
  </div>
  {#if config.editing}
    <CodeMirror bind:value={config.signature} lineWrapping formatOnLoad />
  {/if}
</div>

<style lang="scss" src="./default-signature.scss"></style>
